import { Box, Button, Container, Flex, Heading, Text } from '@chakra-ui/react'
import { useRouter } from 'next/router'
import type { ReactElement } from 'react'

import { useUser } from '@/client/context/user'
import { trackEvent } from '@/client/services/analytics'

import AuthLink from '@/components/Auth/AuthLink'
import ExploreHeaderGraphic from '@/components/Icons/ExploreHeaderGraphic'

export default function ExploreHeaderDefault(): ReactElement {
  const user = useUser()
  const router = useRouter()
  return (
    <Flex
      direction="column"
      bgColor="bg.subtle"
      align="center"
      position="relative"
      py="16px"
      overflow="hidden"
    >
      <Box
        position="absolute"
        display={user.isLoggedOut ? ['none', 'none', 'none', 'inline'] : ['none', 'inline']}
        height={196}
        right="-32px"
        top="-32px"
      >
        <ExploreHeaderGraphic />
      </Box>
      <Container>
        {user.isLoggedOut ? (
          <>
            <Heading size="2xl" as="h2" mb="16px">
              Explore Free Tutoring
            </Heading>
            <Text mb="16px">Find the help you need in math, SAT® Prep, AP® Review and more.</Text>
            <AuthLink mode="signup" returnTo={router.asPath}>
              <Button
                onClick={() =>
                  trackEvent({
                    category: 'Button Click',
                    action: 'Explore Sign-Up',
                  })
                }
                textDecoration="none"
              >
                Get Started
              </Button>
            </AuthLink>
          </>
        ) : (
          <Heading size="2xl" as="h2">
            Explore
          </Heading>
        )}
      </Container>
    </Flex>
  )
}
